import { ICreateTag } from '../../tag/types';

export const TAG_FORM_INITIAL_STATE: ICreateTag = {
  title: '',
};
